(function () {
  const SECTION_IDS = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];

  if (window.__cadisseCartLabelUpsellBound) {
    return;
  }
  window.__cadisseCartLabelUpsellBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-label-upsell-add]');
    if (!button) {
      return;
    }

    event.preventDefault();
    addLabelVariant(button);
  });

  async function addLabelVariant(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.classList.contains('loading')) {
      return;
    }

    const defaultLabel = button.querySelector('[data-label-default]');
    const loadingLabel = button.querySelector('[data-label-loading]');
    setLoadingState(button, defaultLabel, loadingLabel, true);

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const sectionIds =
        cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
          ? cartDrawer.getSectionsToRender().map((section) => {
              return section.id;
            })
          : SECTION_IDS;

      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      if (data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      await refreshCartUI(cartDrawer, data, variantId);
      dismissProductUpsell(button);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-label-upsell',
          productVariantId: variantId,
          cartData: data
        });
      }
    } catch (error) {
      console.error(error);
      setLoadingState(button, defaultLabel, loadingLabel, false);
    }
  }

  function dismissProductUpsell(button) {
    const productUpsell = button.closest('.cart-label-upsell--product');
    if (productUpsell) {
      productUpsell.remove();
    }
  }

  async function refreshCartUI(cartDrawer, data, variantId) {
    let sections = data && data.sections ? data.sections : null;

    if (!sections || !sections['cart-drawer']) {
      sections = await fetchSections(SECTION_IDS);
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && sections && sections['cart-drawer']) {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents({
        id: variantId,
        sections: sections
      });
      return;
    }

    if (sections && (sections['main-cart-footer'] || sections['main-cart-items'])) {
      updateSectionElement('main-cart-items', sections['main-cart-items']);
      updateSectionElement('main-cart-footer', sections['main-cart-footer']);
      updateSectionElement('cart-icon-bubble', sections['cart-icon-bubble']);
      return;
    }

    window.location.href = routes.cart_url;
  }

  async function fetchSections(sectionIds) {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const response = await fetch(`${root}?sections=${sectionIds.join(',')}`);
    if (!response.ok) {
      throw new Error('Failed to refresh cart sections');
    }
    return response.json();
  }

  function updateSectionElement(sectionId, html) {
    if (!html) {
      return;
    }

    const element = document.getElementById(sectionId) || document.getElementById(`shopify-section-${sectionId}`);
    if (!element) {
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming =
      doc.getElementById(sectionId) ||
      doc.querySelector(`#shopify-section-${sectionId}`) ||
      doc.querySelector('.shopify-section');

    if (incoming) {
      element.innerHTML = incoming.innerHTML;
    }
  }

  function setLoadingState(button, defaultLabel, loadingLabel, isLoading) {
    button.classList.toggle('loading', isLoading);
    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }

    if (defaultLabel) {
      defaultLabel.classList.toggle('hidden', isLoading);
    }
    if (loadingLabel) {
      loadingLabel.classList.toggle('hidden', !isLoading);
      loadingLabel.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    }
  }
})();
